module.exports = {
  siteTitle: 'Alistair Elliott | Systems Engineer',
  siteDescription:
    'Alistair Elliott is a jack of all trades and master of some, I work on everything from IT Hardware & Software Mods & IOT/Smart Home Devices to Carpentry, Metal Fabrication & 4WD Modifications and whole lot more.',
  siteKeywords:
    'Alistair Elliott, Alistair, Elliott, AKELLIOTT, Systems Engineer, Network Engineer, Information Security Analyst, Powershell, Weltec',
  siteUrl: 'https://ake.nz',
  siteLanguage: 'en_US',
  name: 'Alistair Elliott',
  location: 'Taranaki, NZ',
  email: 'alistair@ake.nz',
  github: 'https://github.com/AKELLIOTT',
  twitterHandle: '@ALIKELLIOTT',
  socialMedia: [
    {
      name: 'GitHub',
      url: 'https://github.com/AKELLIOTT',
    },
    {
      name: 'Linkedin',
      url: 'https://www.linkedin.com/in/alistairkelliott',
    },
    {
      name: 'Instagram',
      url: 'https://www.instagram.com/alistairkelliott',
    },
    {
      name: 'Twitter',
      url: 'https://twitter.com/ALIKELLIOTT',
    },
  ],

  navLinks: [
    {
      name: 'About',
      url: '/#about',
    },
    {
      name: 'Experience',
      url: '/#jobs',
    },
    {
      name: 'Work',
      url: '/#projects',
    },
    {
      name: 'Contact',
      url: '/#contact',
    },
  ],

  navHeight: 100,

  colors: {
    green: '#64ffda',
    navy: '#0a192f',
    darkNavy: '#020c1b',
  },

  srConfig: (delay = 200) => ({
    origin: 'bottom',
    distance: '20px',
    duration: 500,
    delay,
    rotate: { x: 0, y: 0, z: 0 },
    opacity: 0,
    scale: 1,
    easing: 'cubic-bezier(0.645, 0.045, 0.355, 1)',
    mobile: true,
    reset: false,
    useDelay: 'always',
    viewFactor: 0.25,
    viewOffset: { top: 0, right: 0, bottom: 0, left: 0 },
  }),
};
